import { startOfWeek, startOfDay } from 'date-fns'
import { isMobile } from 'services/Utilities'

const initialState = {
  baseDate: startOfDay(new Date()),
  timeline: undefined,
  loadedEvents: [],
  selectedCount: 0,
  copiedEvents: [],
  currentScheduleView: 'weekly',
  defaultBeginningOfWeekDay: 0
}

// Function to remove an array of events from the loadedEvents array
const removeEvents = (loadedEvents, eventsToRemove) => loadedEvents.filter(({ _id }) => !(eventsToRemove || []).map(({ _id }) => _id).includes(_id))

const events = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_BASE_DATE':
      return { ...state, baseDate: action.date }

    case 'SET_TIMELINE':
      return { ...state, timeline: action.timeline }

    // Save settings for beginning of week and current schedule view
    case 'SET_SETTINGS':
    case 'SET_SETTING_VALUE': {
      const { currentScheduleView, defaultBeginningOfWeekDay } = action.settings || {}
      if (!currentScheduleView && !defaultBeginningOfWeekDay) return state

      let newState = { ...state }

      if (currentScheduleView) newState.currentScheduleView = currentScheduleView
      if (defaultBeginningOfWeekDay) newState.defaultBeginningOfWeekDay = defaultBeginningOfWeekDay
      if (['currentScheduleView', 'defaultBeginningOfWeekDay'].includes(action.name)) newState[action.name] = action.value

      if (newState.currentScheduleView === 'weekly' && typeof newState.defaultBeginningOfWeekDay !== 'undefined' && !isMobile()) {
        newState.baseDate = startOfDay(startOfWeek(state.baseDate, { weekStartsOn: defaultBeginningOfWeekDay }))
      }
      return newState
    }

    case 'SET_EVENTS':
      return { ...state, loadedEvents: action.events }

    case 'EVENTS_CREATED': {
      return { ...state, loadedEvents: [...removeEvents(state.loadedEvents, action.events), ...action.events] }
    }

    case 'EVENTS_UPDATED':
    case 'EVENTS_RESTORED': {
      const loadedEventIds = state.loadedEvents.map(({ _id }) => _id)
      const affectedEvents = action.events.filter(({ _id }) => loadedEventIds.includes(_id))
      return { ...state, loadedEvents: [...removeEvents(state.loadedEvents, affectedEvents), ...affectedEvents] }
    }

    case 'EVENTS_DELETED': {
      return { ...state, loadedEvents: removeEvents(state.loadedEvents, action.events) }
    }

    case 'EVENTS_LEAVE_CREATED': {
      let loadedEvents = [...state.loadedEvents]
      // Find the right shift
      for (const event of loadedEvents)
        if (event._id === action.event.eventId) {
          // Mark the shift as absent/late/leaving early
          switch (action.event.requestTypeId) {
            case 1:
              event.isAbsent = true
              break
            case 2:
              event.isLate = true
              event.arrivalTime = action.event.arrivalTime
              break
            case 3:
              event.isLeavingEarly = true
              event.departureTime = action.event.departureTime
              break
            default:
              break
          }
        }
      return { ...state, loadedEvents: loadedEvents }
    }

    case 'EVENTS_CANCELLED': {
      const loadedEventIds = state.loadedEvents.map(({ _id }) => _id)
      const affectedEvents = action.events.filter(({ _id }) => loadedEventIds.includes(_id))
      return { ...state, loadedEvents: [...removeEvents(state.loadedEvents, affectedEvents), ...(action.showCancelledShift ? affectedEvents : [])] }
    }

    case 'SET_EVENT_SELECTED_COUNT': {
      return { ...state, selectedCount: action.count }
    }

    case 'SET_COPIED_EVENTS': {
      return { ...state, copiedEvents: action.events, copyReferenceDate: action.baseDate }
    }

    default:
      return state
  }
}

export default events
